import * as core from '../../../../../../../core'
import * as prebuilt from '../../../../../../prebuilt'
import * as spaceLite from '../space-lite'

export const RESOURCE = {
  payload: {
    alias: 'space-lite:user-access',
    appAlias: spaceLite.RESOURCE.payload.alias,
    description:
      'Manage survey admins and standard user organization assignments in Space Lite',
    display: {
      isMain: false,
      position: 1,
    },
    name: 'User Access',
    page: { id: prebuilt.Page.Id.SpaceLiteUserAccess },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
